export { ServiceInsightContentDetails } from './ServiceInsightDetails';
